import dayjs from "dayjs";

export const isCareExpired = (expiryDate) => {
  if (!expiryDate) {
    return true;
  }

  const currentDate = dayjs().format("DD/MM/YYYY HH:mm:ss");
  return dayjs(currentDate, "DD/MM/YYYY HH:mm:ss").isAfter(
    dayjs(expiryDate, "DD/MM/YYYY HH:mm:ss")
  );
};

export const serviceHasActiveCare = (service) => {
  if (!service?.payments?.length) {
    return false;
  }

  return service.payments.some(
    (payment) =>
      payment.paymentStatus === "paid" && !isCareExpired(payment.careExpiryDate)
  );
};

export const hasActiveCare = (userDetails) => {
  if (!userDetails?.services?.length) {
    return false;
  }

  return userDetails.services.some(serviceHasActiveCare);
};

export const getPayableServices = (userDetails) => {
  if (!userDetails?.services?.length) {
    return [];
  }

  return userDetails.services.filter((service) => !serviceHasActiveCare(service));
};

export const getServiceLabel = (service) => {
  return `${service.type} (${service.category})`;
};

export const getServiceStatusLabel = (service) => {
  const paidPayments =
    service.payments?.filter((payment) => payment.paymentStatus === "paid") || [];

  if (paidPayments.length === 0) {
    return "Unpaid";
  }

  if (paidPayments.every((payment) => isCareExpired(payment.careExpiryDate))) {
    return "Expired";
  }

  return "Payment required";
};

export const getAdminServiceStatus = (service) => {
  if (serviceHasActiveCare(service)) {
    return "Active";
  }

  const paidPayments =
    service.payments?.filter((payment) => payment.paymentStatus === "paid") || [];

  if (paidPayments.length > 0) {
    return "Expired";
  }

  const hasPendingPayment = service.payments?.some(
    (payment) => payment.paymentStatus === "pending"
  );

  if (hasPendingPayment) {
    return "Pending";
  }

  return "Unpaid";
};

export const getUserActivePlanLabel = (userDetails) => {
  if (!userDetails?.services?.length) {
    return "No plans";
  }

  if (hasActiveCare(userDetails)) {
    return "Yes";
  }

  const hasAnyPlan = userDetails.services.some(
    (service) => service.payments?.length > 0 || service.category
  );

  return hasAnyPlan ? "No" : "No plans";
};
